import { Component, Input } from '@angular/core';

@Component({
	selector: 'tile',
  templateUrl: './tile.component.html',
	styleUrls: ['./tile.component.scss'],
})

export class TileComponent {
	@Input() title: string;
	@Input() description: string;
	@Input() mainValue: string;
	@Input() showProgress: boolean = true;
	@Input() before: string;
	@Input() after: string;
	@Input() value: number = 0;
	@Input() value1: number = 0;
	@Input() value2: number = 0;
	@Input() color: string; // success, brand, warning, danger, primary, info, dark
	@Input() url: string;
}